function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function articaldetail() {
  return import(
    /* webpackChunkName: "page-articaldetail" */ '@/pages/articaldetail.vue'
  )
}
function cardetail() {
  return import(
    /* webpackChunkName: "page-cardetail" */ '@/pages/cardetail.vue'
  )
}
function forgetpassword() {
  return import(
    /* webpackChunkName: "page-forgetpassword" */ '@/pages/forgetpassword.vue'
  )
}
function orderdetail() {
  return import(
    /* webpackChunkName: "page-orderdetail" */ '@/pages/orderdetail.vue'
  )
}
function orderlist() {
  return import(
    /* webpackChunkName: "page-orderlist" */ '@/pages/orderlist.vue'
  )
}
function paybond() {
  return import(/* webpackChunkName: "page-paybond" */ '@/pages/paybond.vue')
}
function payment() {
  return import(/* webpackChunkName: "page-payment" */ '@/pages/payment.vue')
}
function person() {
  return import(/* webpackChunkName: "page-person" */ '@/pages/person.vue')
}
function registered() {
  return import(
    /* webpackChunkName: "page-registered" */ '@/pages/registered.vue'
  )
}
function rule() {
  return import(/* webpackChunkName: "page-rule" */ '@/pages/rule.vue')
}
function searchcar() {
  return import(
    /* webpackChunkName: "page-searchcar" */ '@/pages/searchcar.vue'
  )
}
function shopdetail() {
  return import(
    /* webpackChunkName: "page-shopdetail" */ '@/pages/shopdetail.vue'
  )
}
function shoplist() {
  return import(/* webpackChunkName: "page-shoplist" */ '@/pages/shoplist.vue')
}
function signin() {
  return import(/* webpackChunkName: "page-signin" */ '@/pages/signin.vue')
}
function signup() {
  return import(/* webpackChunkName: "page-signup" */ '@/pages/signup.vue')
}
function specificbusiness() {
  return import(
    /* webpackChunkName: "page-specificbusiness" */ '@/pages/specificbusiness.vue'
  )
}
function tour() {
  return import(/* webpackChunkName: "page-tour" */ '@/pages/tour.vue')
}
function tourdetail() {
  return import(
    /* webpackChunkName: "page-tourdetail" */ '@/pages/tourdetail.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'articaldetail',
    path: 'articaldetail',
    component: articaldetail,
  },
  {
    name: 'cardetail',
    path: 'cardetail',
    component: cardetail,
  },
  {
    name: 'forgetpassword',
    path: 'forgetpassword',
    component: forgetpassword,
  },
  {
    name: 'orderdetail',
    path: 'orderdetail',
    component: orderdetail,
  },
  {
    name: 'orderlist',
    path: 'orderlist',
    component: orderlist,
  },
  {
    name: 'paybond',
    path: 'paybond',
    component: paybond,
  },
  {
    name: 'payment',
    path: 'payment',
    component: payment,
  },
  {
    name: 'person',
    path: 'person',
    component: person,
  },
  {
    name: 'registered',
    path: 'registered',
    component: registered,
  },
  {
    name: 'rule',
    path: 'rule',
    component: rule,
  },
  {
    name: 'searchcar',
    path: 'searchcar',
    component: searchcar,
  },
  {
    name: 'shopdetail',
    path: 'shopdetail',
    component: shopdetail,
  },
  {
    name: 'shoplist',
    path: 'shoplist',
    component: shoplist,
  },
  {
    name: 'signin',
    path: 'signin',
    component: signin,
  },
  {
    name: 'signup',
    path: 'signup',
    component: signup,
  },
  {
    name: 'specificbusiness',
    path: 'specificbusiness',
    component: specificbusiness,
  },
  {
    name: 'tour',
    path: 'tour',
    component: tour,
  },
  {
    name: 'tourdetail',
    path: 'tourdetail',
    component: tourdetail,
  },
]
